import React, { useContext, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { slugifyParam } from 'helpers/querystring'
import { getEnrollmentList } from 'helpers/params'
import { AppContext } from 'stores/App'
import useLocalStorage from 'hooks/useLocalStorage'
import useUrlParams from 'hooks/useUrlParams'
import Checkbox from 'components/Checkbox'
import Label from 'components/Label'
import PrimaryButton from 'components/PrimaryButton'
import FactBox from 'components/FactBox'
import Message from 'components/Message'
import DrupalContext from 'contexts/DrupalContext';

function PanelToggle({ content, enrolledIn, orgNames, orgTypes}) {

  const { t } = useTranslation()
  const {preamble} = useContext(DrupalContext)
  const [state, dispatch] = useContext(AppContext)
  const { urlParams, replaceUrlParams } = useUrlParams()
  const [storage, setStorage] = useLocalStorage('local_page', '')
  const [isChecked, setIsChecked] = useState(false)
  const [initialLogin, setInitialLogin] = useState(false)
  const maxColumns = 2
  const maxItems = 30

  // Remove null values from object
  for(const key in enrolledIn) {
    if (enrolledIn[key] === null) {
      delete enrolledIn[key]
    }
  }

  useEffect(() => {

    setInitialLogin(typeof storage === "string")

    setStorage({ urlParams, apiParams: state.params, entityParams: state.entity_params, initialLogin})
  }, [isChecked])

  const handleSave = () => {
    setStorage({ urlParams, apiParams: state.params, entityParams: state.entity_params, initialLogin})
    setIsChecked(!isChecked)
  }

  const handleReset = () => {
    const [newApiParams, newEntityParams, newUrlParams] = getEnrollmentList(enrolledIn)

    Object.keys(newUrlParams).forEach((id) => {
      const checkbox = document.querySelector(`#${id}`)
      if (checkbox) checkbox.checked = true
    })

    dispatch({type: 'UPDATE_PARAMS', payload: newApiParams})
    dispatch({type: 'UPDATE_ENTITY_PARAMS', payload: newEntityParams})
    replaceUrlParams(newUrlParams)

    handleSave()
  }

  const getOrganizationType = entity => orgTypes[entity] && orgTypes[entity][1]

  const checkForStudentOrganization = ladokId => Object.keys(enrolledIn).includes(ladokId)

  return (
    <>
      <div className="row collapse u-pt-200 u-pb-100">
        <div className="columns small-12 medium-9 xmedium-9 u-pr-150">
          <FactBox content={preamble} />
        </div>
        <div className="columns small-12 medium-3 xmedium-3 u-pt-150">
          <PrimaryButton
            label={t('select_my_information_button')}
            size="tiny"
            fullWidth="false"
            onClick={handleReset}
          />
        </div>
      </div>
      <div className="layout layout--filter-content">
        <div className="row collapse u-pb-175">
          {
          content.length ? content[0].filters.map((facet) => {

            const column1 = facet.children.length > maxItems ? facet.children.slice(0, facet.children.length / maxColumns) : facet.children || []
            const column2 = facet.children.length > maxItems ? facet.children.slice(facet.children.length / maxColumns, facet.children.length) : []

            return (
              column1.length &&
              <>
              <div className="columns small-12 medium-12 xmedium-4">
                <h4 className="u-mb-25">{getOrganizationType(facet.displayName)}</h4>
                <hr className={facet.displayName === 'F' ? 'u-mr-200' : ''} />
              {
                column1.map((child) => (
                    <><Checkbox
                      id={slugifyParam(`${facet.displayName  }_${  child.id}`)}
                      tabIndex={0}
                      value={1}
                      apiDataParams={`${facet.displayName  }/${  child.id}`}
                      entityParams={facet.displayName}
                      label={child.displayName}
                      modifierContainerClasses="u-pr-200"
                      onSave={handleSave}
                      isDisabled={checkForStudentOrganization(child.id)}
                      />
                      {checkForStudentOrganization(child.id) &&
                      (<Label
                        text={`↳ ${t('you_are_reading_here')}`}
                        modifierClasses="u-text-2xs u-ml-150 label--framed label__icon u-text-white u-inline-block"
                      />)}
                    </>
                  ))
              }
              </div>
              {
                column2.length > 0 &&
                <div className="columns small-12 medium-12 xmedium-4">
                  <hr className="filter-bar--last-column"/>
                {
                  column2.map((child) => (
                      <><Checkbox
                        id={slugifyParam(`${facet.displayName  }_${  child.id}`)}
                        tabIndex={0}
                        value={1}
                        apiDataParams={`${facet.displayName  }/${  child.id}`}
                        entityParams={facet.displayName}
                        label={child.displayName}
                        onSave={handleSave}
                        isDisabled={checkForStudentOrganization(child.id)}
                        />
                        {checkForStudentOrganization(child.id) &&
                        (<Label
                          text={`↳ ${t('you_are_reading_here')}`}
                          modifierClasses="u-text-2xs u-ml-150 label--framed label__icon u-text-white u-inline-block"
                        />)}
                      </>
                    ))
                }
                </div>
              }
              </>
            )
          }) :
            <Message message={t('error_load_data_organizations')} error />
        }
        </div>
      </div>
    </>
  )
}

export default PanelToggle
